const translations = {
  name: 'Name',
  role: 'Role',
};

export default translations;
